import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

export default class StdAttributeService {
  static async detail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdAttribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async list(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdAttribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async create(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdAttribute', payload))
    return Callback(err, res)
  }
  static async update(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdAttribute', payload))
    return Callback(err, res)
  }
  static async remove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(wizStandardInstance.delete('/api/std/StdAttribute', payload))
    return Callback(err, res)
  }
  static async upload(payload) {
    RecordOperation({ type: 'import' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdAttribute/import', payload))
    return Callback(err, res)
  }
  static async exportFile(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdAttribute/export', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  static async downloadTemplate(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdAttribute/download', payload))
    return Callback(err, res)
  }
  // 获取最大序号值
  static async getMaxSeqno(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdAttribute/max-seqno?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
}
